import useLoadRatings from './functions/useLoadRatings';
import usePagination from './functions/usePagination';
import useSearches from './functions/useSearches';

export default function useActivitiesRatings() {
  const {
    filteredRatings,
    setFilteredRatings,
    setRatingsSplited,
    ratingsSplited,
    currentPage,
    setCurrentPage,
    pagesQuantity,
    handlePageChange,
  } = usePagination();

  const {
    isLoadLoading,
    fullRatings,
    doesListApiHasError,
    activitiesList,
    teacherRateOptions,
    contentRateOptions,
    durationRateOptions,
    loadRatings,
  } = useLoadRatings({
    setRatingsSplited,
    setFilteredRatings,
    setCurrentPage,
  });

  const {
    selectedActivity,
    selectedTeacherRate,
    selectedContentRate,
    selectedDurationRate,
    selectedPeriod,
    handleActivityChange,
    handleTeacherRateChange,
    handleContentRateChange,
    handleDurationRateChange,
    handlePeriodChange,
    handleClearPeriod,
  } = useSearches({
    fullRatings,
    setRatingsSplited,
    setFilteredRatings,
  });

  function handleTryAgain() {
    loadRatings();
  }

  const isLoading = isLoadLoading;

  return {
    isLoading,
    fullRatings,
    doesListApiHasError,
    filteredRatings,
    handleTryAgain,
    pagesQuantity,
    currentPage,
    activitiesList,
    selectedActivity,
    handleActivityChange,
    teacherRateOptions,
    selectedTeacherRate,
    handleTeacherRateChange,
    contentRateOptions,
    selectedContentRate,
    handleContentRateChange,
    durationRateOptions,
    selectedDurationRate,
    handleDurationRateChange,
    selectedPeriod,
    handlePeriodChange,
    handleClearPeriod,
    handlePageChange,
    ratingsSplited,
  };
}
